<template>
    <div class="time flex">
        <span>北斗标准时间：</span>
        <span style="letter-spacing: 1px;">{{ bdTime.data }} {{ bdTime.time }}</span>
    </div>
</template>

<script>
import { time } from "@/utils/index";
export default {
    components: {},
    data() {
        return {
            timer: null,
            bdTime: {
                data: '0000-00-00',
                time: '00:00:00'
            },
        };
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {
        this.setTimer();
    },
    methods: {
        setTimer() {
            this.timer = setInterval(() => {
                this.bdTime = time(new Date())
            }, 1000)
        }
    },
    beforeDestroy() {
        clearInterval(this.timer);
        this.timer = null;
    }
};
</script>

<style scoped ></style>
